import http from "@/services/api.service";
import jwt_decode from "jwt-decode";
import IUser from "@/types/user.interface";

class UserService {

    getUser(credits: number): Promise<IUser> {
        return new Promise(resolve => {
            const token = localStorage.getItem('tokenJWT');
            const decoded: any = jwt_decode(token);


            const user = {
                id: decoded.id,
                name: decoded.name,
                email : decoded.username,
                notifications : [
                    {
                        "title": "first notif",
                        "content": "contenu"
                    },
                    {
                        "title": "first notif",
                        "content": "contenu"
                    },
                    {
                        "title": "first notif",
                        "content": "contenu"
                    }
                ],
                company : decoded.entity_name,
                credits : credits
            };

            setTimeout(() => {
                resolve(user);
            }, 0);
        });
    }

    getRoles() {
        return new Promise(resolve => {
            const token = localStorage.getItem('tokenJWT');
            const decoded: any = jwt_decode(token);

            setTimeout(() => {
                resolve(decoded.roles);
            }, 0);
        });
    }

    setUser(data) {
        localStorage.setItem('tokenJWT', data.access_token);
        localStorage.setItem('expiration', data.expires_in);
        localStorage.setItem('refreshToken', data.refresh_token);
        localStorage.setItem('scope', data.scope);
        localStorage.setItem('tokenType', data.token_type);
    }

    getJWT(code: string) {
        const formData = new FormData();
        formData.append('grant_type', "authorization_code");
        formData.append('code', code);
        formData.append('redirect_uri', process.env.VUE_APP_REDIRECT_URI);
        formData.append('client_id', process.env.VUE_APP_CLIENT_ID);
        formData.append('client_secret', process.env.VUE_APP_CLIENT_SECRET);

        return http.post(process.env.VUE_APP_AUTH_URI + '/oauth/v2/token', formData,
            { headers: { 'Content-Type': 'multipart/form-data',}
            });
    }

    getUserCredit() {
        const token = localStorage.getItem('tokenJWT');
        const decoded: any = jwt_decode(token);
        const url = process.env.VUE_APP_CREDIT_URI;
        return http.get(url + "/personal_balance/" + decoded.id + "/produit/2",
            {
                headers: {'Authorization': "Bearer " + token}
            });
    }


}

export default new UserService();
